import { load } from '@shopify/theme-sections';
import 'nodelist-foreach-polyfill';

import '../../assets/styles/theme.scss';
import React from 'react';
import ReactDOM from 'react-dom';
// import App from './components/App';
import SideCart from './components/SideCart';

import 'objectFitPolyfill';
import 'picturefill';

import './sections/header';
import './sections/footer';
import './sections/hero-slider-split';
import './sections/hero-slider-full';
import './sections/featured-video';
import './sections/featured-products';
import './sections/featured-collection';
import './sections/featured-testimonials';
import './sections/collection-list';
import './sections/trust-indicators';
import './sections/logo-list';

const ecommerceEnable = window.theme.ecommerce || false;

document.addEventListener('DOMContentLoaded', function() {
  load('*');

  var trigger = new ScrollTrigger(
    {
      toggle: {
        visible: 'animate-finish',
        hidden: 'animate-start',
      },
      offset: {
        x: 0,
        y: window.innerHeight / 4,
      },
      once: true,
    },
    document.body,
    window
  );

  var scroll = new SmoothScroll('a[href*="#"]');

  const rteTables = document.querySelectorAll('.rte table');
  if (rteTables.length > 0) {
    rteTables.forEach((item) => {
      var wrapper = document.createElement('div');
      wrapper.classList.add('rte-table');
      item.parentNode.insertBefore(wrapper, item);
      wrapper.appendChild(item);
    });
  }
});

// ReactDOM.render(
//   <App />,
//   document.getElementById('app'),
// );

if (ecommerceEnable) {
  ReactDOM.render(<SideCart />, document.getElementById('side-cart-app'));
}
